import { NpIcon } from "src/components/np-design/components/NpIcon"

export type NpStarsProps = {
  stars: number
}

export const NpStars = ({ stars }: NpStarsProps) => {
  const className = "size-8 -m-1.5"

  return (
    <div className="flex items-center gap-2" aria-label={`${stars} von 5 Sternen`}>
      <div className="text-np-green flex gap-0.5">
        {[...Array(5)].map((_, index) => {
          const n = index + 1

          if (stars >= n - 0.25) {
            return <NpIcon key={index} name="star_filled" className={className} />
          }
          if (stars >= n - 0.75) {
            return <NpIcon key={index} name="star_filled_half" className={className} />
          }
          return <NpIcon key={index} name="star" className={className} />
        })}
      </div>
    </div>
  )
}
